export default {
  getTypes: '/courier/api/trade/types',
  getTransactionsData: '/gateway/capp/WithDrawTradeFacade/queryCourierWithdrawRecord'
}
